import React from 'react';

export default class Page9 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>HINTS AND TIPS
                                            </div>
                                            <p>The following hints and tips will help you with your lateral
                                                thinking.</p>
                                            <div className="border_subtitle">Data focus</div>
                                            <div className="paraspace"><p>Think about what you can learn
                                                from the information you have. Ask yourself the following
                                                questions:</p></div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>What are the gaps in your knowledge?</p></li>
                                                <li><p>What is your intuition about the situation?</p></li>
                                                <li><p>What ‘gut reactions’ and emotions do you have?</p>
                                                </li>
                                                <li><p>What would you say if you were thinking cautiously
                                                    and defensively about this situation?</p></li>
                                                <li><p>Why might things not work out?</p></li>
                                                <li><p>What can you put in place to avoid this
                                                    happening?</p></li>
                                                <li><p>What would the optimistic view of this situation
                                                    be?</p></li>
                                                <li><p>If you were to think creatively about this issue,
                                                    what solutions would you suggest?</p></li>

                                            </ul>
                                            <br/>

                                            <div className="border_subtitle">Provocation</div>
                                            <p>Suggest a deliberately provocative solution to a problem,
                                                one that seems ‘silly’ or not politically
                                                correct, perhaps. Doing this often alters our own
                                                perspective and can initiate ideas which can
                                                then be refined into realistic and successful solutions.
                                                (Don’t forget, you’re doing this for a
                                                constructive reason, not just to stir things up!)</p>
                                            <div className="border_subtitle">Challenge</div>
                                            <p>Remember to challenge the way things are done. Never do
                                                something just because it’s always
                                                been done a particular way.</p>
                                            <div className="border_subtitle">Modelling
                                            </div>
                                            <p>Compare whatever problem you’re mulling over now, to
                                                something entirely different – just to get
                                                the creative juices flowing. So, imagine it’s a bottle
                                                of coke! Say, for example, your boss wants you
                                                to come up with an idea for a new product.</p>
                                            <p>First you might think about packaging – how it looks to
                                                the outside world. Then, you might think
                                                about branding – what it ‘means’. You might actually
                                                think about the stuff inside – the product.
                                                Then, what about the bubbles – this product can move,
                                                explode, even! Finally, think about
                                                production costs – how much do you need for each stage
                                                of the process?</p>
                                            <div className="border_subtitle">Challenge your
                                                assumptions
                                            </div>
                                            <p>Think about the decision you’ve made and what evidence
                                                you have that it’s the right one.
                                                Check the supporting evidence for any assumptions you
                                                have made and, if there isn’t any, think
                                                of alternatives.</p>
                                            <div className="border_subtitle">Don’t take things
                                                literally
                                            </div>
                                            <p>If you take things too literally you might miss
                                                alternatives. Try considering more imaginative ideas
                                                and the opportunities these might create. Don’t dismiss
                                                these as unrealistic or unworkable,
                                                without giving them a chance.</p>
                                            <div className="border_subtitle">Be creative</div>
                                            <p>As we said earlier, think of different uses for things –
                                                not just the obvious and familiar, and do use
                                                some of the techniques described in this tool.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page10')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}